import React from 'react';
import { Button, Box, Text } from 'components/ui';
import { wrapFunctionalComponent } from 'utils/framework';
import localeUtils from 'utils/LanguageLocale';
import UrlUtils from 'utils/Url';
import InvoiceNoLongerAvailableEN from 'components/Invoice/InvoiceNoLongerAvailable/locales/InvoiceNoLongerAvailable_en_US';
import InvoiceNoLongerAvailableFR from 'components/Invoice/InvoiceNoLongerAvailable/locales/InvoiceNoLongerAvailable_fr_CA';

const getText = localeUtils.getLocalisedDataFromResource(InvoiceNoLongerAvailableEN, InvoiceNoLongerAvailableFR);

function InvoiceNoLongerAvailable() {
    return (
        <Box
            paddingX={[4, 9]}
            paddingTop={[6, 7]}
        >
            <Text
                fontSize='xl'
                fontWeight='bold'
                is={'p'}
            >
                {getText('invoiceNoLongerAvailable')}
            </Text>
            <p>{getText('contactInfo')}</p>
            <Box
                marginTop={5}
                maxWidth={250}
            >
                <Button
                    type='submit'
                    variant='primary'
                    block={true}
                    onClick={() => UrlUtils.redirectTo('/')}
                >
                    {getText('homePage')}
                </Button>
            </Box>
        </Box>
    );
}

InvoiceNoLongerAvailable.propTypes = {};

export default wrapFunctionalComponent(InvoiceNoLongerAvailable, 'InvoiceNoLongerAvailable');
